import clsx from 'clsx';
import React from 'react';
import useStyles from './CustomStepIconStyles';
var CustomStepIcon = function (props) {
    var _a;
    var styles = useStyles();
    var active = props.active, completed = props.completed;
    return (React.createElement("article", { className: clsx(styles.root, (_a = {},
            _a[styles.active] = active,
            _a[styles.completed] = completed,
            _a)) },
        React.createElement("div", { className: styles.circle })));
};
export default CustomStepIcon;
